<template>
  <v-container>
    <v-row>
      <v-col>
        <v-container class="bordered bg-white mb-4">
          <!-- <CalcInputSelect
            class="mb-4"
            entity="variant"
            field="source_type_part"
            :node-id="nodeId"
          /> -->

          <NormalInput
            :id="nodeId"
            class="mb-4"
            field="item_number" />

          <CalcInputNumber
            :id="nodeId"
            class="mb-4"
            field="quantity_of_part_part"
            :hint="t('entities.variant.hints.quantity_of_part_part')"
            :rules="[required, positive]" />

          <TaggedInput
            :id="nodeId"
            class="mb-4"
            field="manufacturing_feature"
            no-calculation />
        </v-container>
        <v-container class="bordered bg-white">
          <NotesEditor
            :id="nodeId"
            field="basic_data_notes"
            :placeholder="t('entities.variant.fields.base_data_notes')" />
        </v-container>
      </v-col>
      <v-col>
        <CarouselWithUpload
          field="base-data"
          :node-id="nodeId" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useTranslation } from "i18next-vue";

import { useCommonRules } from "@/validations/common";

import CalcInputSelect from "@/components/Elements/CalcInputSelect.vue";
import CarouselWithUpload from "@/components/Elements/CarouselWithUpload.vue";
import TaggedInput from "@/components/Elements/TaggedInput.vue";
import { useSpaceStore } from "../../../../stores/spaceStore";
import NormalInput from "@/components/Elements/NormalInput.vue";
import NotesEditor from "@/components/Elements/NotesEditor.vue";
import CalcInputNumber from "@/components/Elements/CalcInputNumber.vue";

const { t } = useTranslation();
const spaceStore = useSpaceStore();
const { required, positive } = useCommonRules(t);

const variant = ref(null);

const props = defineProps({
  nodeId: {
    type: String,
    required: true
  }
});

onMounted(() => {
  variant.value = spaceStore.getElement(props.nodeId);
});
</script>
